import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Zoom from "@mui/material/Zoom";

export default function MouseOverPopover({
    text,
    withAutocomplete = false,
    withCheckbox = false,
}) {
    const [open, setOpen] = useState(false);

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipToggle = () => {
        setOpen((isOpen) => !isOpen);
    };

    return (
        <div>
            <ClickAwayListener onClickAway={handleTooltipClose}>
                <div>
                    <Tooltip
                        onClose={handleTooltipClose}
                        open={open}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                        title={
                            typeof text === "object" ? (
                                text
                            ) : (
                                <div
                                    dangerouslySetInnerHTML={{ __html: text }}
                                />
                            )
                        }
                        TransitionComponent={Zoom}
                        placement="right"
                    >
                        <Button
                            variant="contained"
                            color="tooltip"
                            className={`mouse-over-popover ${
                                withAutocomplete
                                    ? "withAutoComplete"
                                    : withCheckbox
                                      ? "withCheckBox"
                                      : ""
                            }`}
                            onClick={handleTooltipToggle}
                        >
                            <FontAwesomeIcon icon={faInfo} color="white" />
                        </Button>
                    </Tooltip>
                </div>
            </ClickAwayListener>
        </div>
    );
}
